import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap, Params, Router} from '@angular/router';
import {Response, StaticMethods} from '../../model/GeneralModels';
import {FinanceService} from '../../services/finance.service';

@Component({
  selector: 'app-bank-callback',
  templateUrl: './zarinpal.component.html',
  styleUrls: [
    './zarinpal.component.css'
  ]
})
export class ZarinpalComponent implements OnInit {
  params: any = {};
  message: string;
  success = false;
  productName: string;
  serverUrl: string;
  baseUrl: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private  service: FinanceService,
    private router: Router) {
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.productName = params.productName;
      console.log(params);
      this.baseUrl = StaticMethods.getBaseUrl(this.productName);
      if (this.productName === 'HEALTH') {
        this.serverUrl = 'samanAPI/Payment/';
      } else {
        this.serverUrl = this.baseUrl + '/payment';
      }
      this.activatedRoute.queryParams.subscribe(paramsQuery => {
        this.params.Authority = paramsQuery.Authority;
        this.params.Status = paramsQuery.Status;
      });
      this.service.zarinPalPaymentCallback(this.params, this.baseUrl).subscribe((response: Response) => {
        if (response.success) {
          switch (this.params.Status) {
            case 'OK':
              if (!response.success) {
                // tslint:disable-next-line:max-line-length
                this.message = 'پرداخت با موفقیت انجام نگردید در صورتیکه طی 72 ساعت مبلغ کسر شده به حساب شما واریز نشد  با شماره 02186112835 تماس حاصل فرمایید';
              } else {
                this.message = 'پرداخت شما با موفقیت انجام شد';
                this.success = true;
              }
              break;
            default:
              // tslint:disable-next-line:max-line-length
              this.message = 'پرداخت با موفقیت انجام نگردید در صورتیکه طی 72 ساعت مبلغ کسر شده به حساب شما واریز نشد  با شماره 02186112835 تماس حاصل فرمایید';
              break;
          }
        } else {
          // tslint:disable-next-line:max-line-length
          this.message = 'پرداخت با موفقیت انجام نگردید در صورتیکه طی 72 ساعت مبلغ کسر شده به حساب شما واریز نشد  با شماره 02186112835 تماس حاصل فرمایید';
        }
      });
    });
  }

  returnToApp() {
    this.router.navigate([`/${this.productName}/requests`]);
  }
}
